import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import TextArea from 'shared/components/textarea';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { getDocumentDetails } from 'redux/actions/documentActions';

import { LabelRequiredInput, LabelError, LabelInput } from 'shared/components/Labels';
import { TextField } from 'shared/components/form/Inputs';
import DateTime from 'shared/components/DateTime';
import { Button } from 'shared/components/Buttons';

import { colors } from 'shared/defaultTheme';
import { cleanSpaceString } from 'shared/utils';

const Form = ({ onCancel, onSubmit }) => {
  const dispatch = useDispatch();
  const documentState = useSelector((state) => state.document);
  const { t } = useTranslation();
  const [alert, setAlert] = useState([]);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      ...alert,
    },
  });

  useEffect(() => {
    setAlert(
      documentState.documentDtails?.alerts !== undefined ||
        documentState.documentDtails?.alerts?.length > 0
        ? documentState.documentDtails?.alerts[0]
        : []
    );
    reset({ ...alert });
  }, [alert, documentState.documentDtails?.alerts]);

  const handleCancel = () => {
    setAlert([]);
    dispatch(getDocumentDetails(null));
    onCancel();
  };

  return (
    <Row className="row-content w-100">
      <Col sm={12}>
        <form className="form form-field" noValidate onSubmit={handleSubmit(onSubmit)}>
          <Row className="w-100 mb-3">
            <Col sm={12}>
              <div className="form__form-group">
                <LabelRequiredInput
                  className="form__form-group-label"
                  label={t('notification_column_issue')}
                  color={colors.black}
                  error={errors.title !== undefined}
                />
                <Controller
                  name="title"
                  control={control}
                  defaultValue=""
                  rules={{ required: { value: true, message: t('general_required_field') } }}
                  render={({ field }) => (
                    <TextField
                      value={field.value}
                      onChange={(e) => {
                        const newEvent = cleanSpaceString(e);
                        field.onChange(newEvent);
                      }}
                      onBlur={field.onBlur}
                      error={errors.tile !== undefined}
                    />
                  )}
                />
                {errors.tile && <LabelError label={errors.tile.message} />}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form__form-group">
                <LabelRequiredInput
                  className="form__form-group-label"
                  label={t('notification_date_alert_title')}
                  color={colors.black}
                  error={errors.title !== undefined}
                />
                <Controller
                  name="date"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: { value: true, message: t('general_required_field') },
                  }}
                  render={({ field }) => (
                    <DateTime
                      onChange={field.onChange}
                      error={errors.date !== undefined}
                      value={field.value}
                      className="w-100 float-none"
                    />
                  )}
                />
                {errors.date && <LabelError label={errors.date.message} />}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form__form-group">
                <LabelInput label={t('general_text_description')} color={colors.black} />
                <Controller
                  name="description"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: { value: false, message: t('general_required_field') },
                  }}
                  render={({ field }) => (
                    <TextArea
                      value={field.value}
                      onChange={field.onChange}
                      error={errors.description !== undefined}
                      row="20"
                      cols="30"
                    />
                  )}
                />
                {errors.description && <LabelError label={errors.description.message} />}
              </div>
            </Col>
          </Row>
          <Row className="w-100">
            <Col className="d-flex flex-row justify-content-end" sm={12}>
              <Button
                className="text-uppercase mr-4"
                type="button"
                color="secondary"
                label={t('general_button_cancel')}
                onClick={() => handleCancel()}
              />
              <Button
                className="text-uppercase"
                type="submit"
                color="primary"
                label={t(
                  documentState.documentDtails?.alerts?.length > 0
                    ? 'general_button_save'
                    : 'general_add'
                )}
              />
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
};

Form.defaultProps = {};

Form.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
